﻿import global from '../../../../../shared/utils/global.js';
import { fetchTrucks, fetchTrailers } from '../unitdiagrams/repeaters/units.api.js';
import { createUnitGroup, updateUnitGroupName, getUnitGroupUnits, updateUnitGroupUnits, deleteUnitGroup, getUnitGroupData } from './unitgroups.api.js';
import { displayMainPane, createMainUnitContainer } from "../main/mainpage.js";
import { displayStatusSummary } from '../main/unitstatusesdiagrams.js';
import { displayUnitDetail } from "../unitdiagrams/detailpage.js";

var gEditUnitGroup = false;

export const registerUnitGroupEvents1 = (units) => {

  const unitsListButtonMain = document.getElementById('unitslistbuttonmain');
  unitsListButtonMain.onclick = (e) => {
    e.stopImmediatePropagation();

    global.mainUnitsListSelected = true;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    document.getElementById('rbtnTemperature').disabled = false;
    document.getElementById('rbtnVoltage').disabled = false;

    displayMainPane(units);
  };

  const unitGroupsButtonMain = document.getElementById('unitgroupsbuttonmain');
  unitGroupsButtonMain.addEventListener('click', function clickHandler(e) {
    global.mainUnitsListSelected = false;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    document.getElementById('rbtnPressure').checked = true;
    global.selectedMetric = 'PRESSURE';

    document.getElementById('rbtnTemperature').disabled = true;
    document.getElementById('rbtnVoltage').disabled = true;

    displayMainPane(units);
  });

  const unitGroupsMenuMain = document.getElementById('unitgroupsmenumain');
  unitGroupsMenuMain.addEventListener('click', function clickHandler(e) {
    if (e.target.tagName === 'LI') {
      switch (e.target.id) {
        case 'newunitsgroupmain':
          openNewUnitGroupForm(units);
          break;
        case 'editdeleteunitsgroupmain':
          openEditDeleteUnitsGroupForm(units);
          break;
        case 'assignunitsgroupmain':
          openAssignUnitsGroupForm(units);
          break;
      }
    }
  }, false);

  const unitgroupsmenu = document.getElementById('unitgroupsmenu');
  unitgroupsmenu.addEventListener('click', function clickHandler(event) {
    if (event.target.tagName === 'LI') {
      switch (event.target.id) {
        case 'newunitsgroup':
          openNewUnitGroupForm(units);
          break;
        case 'editdeleteunitsgroup':
          openEditDeleteUnitsGroupForm(units);
          break;
        case 'assignunitsgroup':
          openAssignUnitsGroupForm(units);
          break;
      }
    }
  }, false);

  const unitslistbutton = document.getElementById('unitslistbutton');
  unitslistbutton.addEventListener('click', function clickHandler(e) {
    global.showMainPage = true;
    global.mainUnitsListSelected = true;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    displayMainPane(units);
  });

  const unitGroupsButton = document.getElementById('unitgroupsbutton');
  unitGroupsButton.addEventListener('click', function clickHandler(e) {
    global.mainUnitsListSelected = false;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    document.getElementById('rbtnTemperature').disabled = true;
    document.getElementById('rbtnVoltage').disabled = true;

    document.getElementById('rbtnPressure').checked = true;
    global.selectedMetric = 'PRESSURE';

    displayMainPane(units);
  });
};

export const registerUnitGroupEvents = (units) => {
  const setDefaults = ({ isMainList = false, showTempVolt = true } = {}) => {
    global.mainUnitsListSelected = isMainList;
    global.selectedUnitId = 0;
    global.selectedGroupId = 0;
    global.selectedGroupUnits = [];

    const temp = document.getElementById('rbtnTemperature');
    const volt = document.getElementById('rbtnVoltage');

    if (temp && volt) {
      temp.disabled = !showTempVolt;
      volt.disabled = !showTempVolt;
    }

    if (!showTempVolt) {
      const pressure = document.getElementById('rbtnPressure');
      if (pressure) pressure.checked = true;
      global.selectedMetric = 'PRESSURE';
    }
  };

  const handleMenuClick = (e, menuMapDetailPage) => {
    if (e.target.tagName === 'LI') {
      const action = menuMapDetailPage[e.target.id];
      if (action) action();
    }
  };

  const menuMapMainPage = {
    'newunitsgroupmain': () => openNewUnitGroupForm(units),
    'editdeleteunitsgroupmain': () => openEditDeleteUnitsGroupForm(units),
    'assignunitsgroupmain': () => openAssignUnitsGroupForm(units)
  };

  const menuMapDetailPage = {
    'newunitsgroup': () => openNewUnitGroupForm(units),
    'editdeleteunitsgroup': () => openEditDeleteUnitsGroupForm(units),
    'assignunitsgroup': () => openAssignUnitsGroupForm(units)
  };

  document.getElementById('unitslistbuttonmain')?.addEventListener('click', (e) => {
    e.stopImmediatePropagation();
    setDefaults({ isMainList: true, showTempVolt: true });
    displayMainPane(units);
  });

  document.getElementById('unitgroupsbuttonmain')?.addEventListener('click', () => {
    setDefaults({ isMainList: false, showTempVolt: false });
    displayMainPane(units);
  });

  document.getElementById('unitgroupsmenumain')?.addEventListener('click', (e) =>
    handleMenuClick(e, menuMapMainPage)
  );

  document.getElementById('unitgroupsmenu')?.addEventListener('click', (e) =>
    handleMenuClick(e, menuMapDetailPage)
  );

  document.getElementById('unitslistbutton')?.addEventListener('click', () => {
    global.showMainPage = true;
    setDefaults({ isMainList: true, showTempVolt: true });
    displayMainPane(units);
  });

  document.getElementById('unitgroupsbutton')?.addEventListener('click', () => {
    setDefaults({ isMainList: false, showTempVolt: false });
    displayMainPane(units);
  });
};

export const getUnitGroupName = () => {
  let unitGroups = global.unitGroups;
  let unitGroupId = global.selectedGroupId;
  let unitGroupName = "";
  if (unitGroups.length > 0) {
    for (let i = 0; i < unitGroups.length; i++) {
      if (unitGroups[i].unitGroupId === unitGroupId) {
        unitGroupName = unitGroups[i].unitGroupName;
        break;
      }
    }
  } else {
    return "";
  }
  return unitGroupName;
};

// Helper to clear all children of an element efficiently
const clearChildren = (element) => {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
};

// Helper to update the metric radio buttons and global state based on group selection
const updateMetricControls = (enableTemperatureAndVoltage) => {
  const rbtnTemperature = document.getElementById('rbtnTemperature');
  const rbtnVoltage = document.getElementById('rbtnVoltage');
  const rbtnPressure = document.getElementById('rbtnPressure');

  if (rbtnTemperature) rbtnTemperature.disabled = !enableTemperatureAndVoltage;
  if (rbtnVoltage) rbtnVoltage.disabled = !enableTemperatureAndVoltage;

  if (!enableTemperatureAndVoltage && rbtnPressure) {
    rbtnPressure.checked = true;
    global.selectedMetric = 'PRESSURE';
  }
};

// Helper to create a unit container div (assuming createMainUnitContainer is defined elsewhere)
const createUnitDiv = (unit, isAssigned) => {
  return createMainUnitContainer(unit, isAssigned);
};

// ... (previous helper functions and global scope)

export async function displayMainUnitsGroupsList(units) {
  try {
    const unitGroups = await getUnitGroupData();
    global.unitGroups = unitGroups;
    global.units = units;

    const unitsGroupsListMain = document.getElementById('unitslistmain');
    clearChildren(unitsGroupsListMain);

    const unitsGroupsListMainContainerDiv = document.createElement('div');
    unitsGroupsListMainContainerDiv.id = 'unitgroupslistcontainer';
    unitsGroupsListMainContainerDiv.className = 'unitslistcontainer';
    unitsGroupsListMain.appendChild(unitsGroupsListMainContainerDiv);

    let activeGroupDiv = null;
    const currentSelectedGroupId = global.selectedGroupId;

    // Create a comprehensive unitsById Map:
    // Key: unitId of primary units (trucks/standalone trailers) OR Id of linked trailers
    // Value: The main unit object (truck or standalone trailer)
    const unitsById = new Map();
    for (const unit of units) {
      // Add the main unit's ID
      unitsById.set(unit.unitId, unit);

      // If the unit is a truck and has linked trailers, add their IDs too,
      // mapping them back to the parent truck object.
      if (unit.trailers && Array.isArray(unit.trailers)) {
        for (const trailer of unit.trailers) {
          if (trailer.Id) { // Assuming trailer object has an 'Id' property
            unitsById.set(trailer.Id, unit); // Map linked trailer's ID to its parent truck
          }
        }
      }
    }

    // Function to render units within a given group div
    const renderGroupUnits = (targetGroupDiv, groupData) => {
      const existingGroupNameDiv = targetGroupDiv.querySelector('.group-name');
      clearChildren(targetGroupDiv);
      if (existingGroupNameDiv) {
        targetGroupDiv.appendChild(existingGroupNameDiv);
      } else {
        targetGroupDiv.innerHTML = `${groupData.unitGroupName}`;
      }

      const selectedGroupUnits = []; // This will hold the actual unit/trailer objects to display
      const combinedGroupUnits = [...groupData.trucks, ...groupData.trailers]; // Units assigned to the group

      for (const groupUnit of combinedGroupUnits) {
        // Determine the ID from the groupUnit (could be unitId or Id for trailers)
        const idToLookup = groupUnit.unitId || groupUnit.Id;

        // Retrieve the main unit (truck or standalone trailer) from the map
        const mainUnit = unitsById.get(idToLookup);

        let unitToDisplay = null; // This will be the specific unit/trailer object to render

        if (mainUnit) {
          if (mainUnit.unitId === idToLookup) {
            // Case 1: The ID from groupUnit directly matches the mainUnit's unitId.
            // This means groupUnit is either a standalone truck, a standalone trailer,
            // or the primary truck of a linked system.
            if (mainUnit.name === groupUnit.name) {
              unitToDisplay = mainUnit;
            }
          } else if (mainUnit.trailers && Array.isArray(mainUnit.trailers)) {
            // Case 2: The ID from groupUnit is a linked trailer's ID,
            // and mainUnit is the parent truck containing this trailer.
            const linkedTrailer = mainUnit.trailers.find(
              trailer => trailer.Id === idToLookup && trailer.name === groupUnit.name
            );

            if (linkedTrailer) {
              // If createUnitDiv and displayUnitDetail expect a 'unitId' property
              // on the object, we should create a new object for the linked trailer
              // to ensure this property exists, or ensure they handle 'Id' directly.
              // For consistency, let's augment the linked trailer object.
              unitToDisplay = {
                ...linkedTrailer,           // Copy all properties from the linked trailer
                unitId: linkedTrailer.Id,   // Ensure 'unitId' is present for consistency
                parentTruck: mainUnit       // Optional: reference to the parent truck
              };
            }
          }
        }

        // If a valid unit (or linked trailer) was found and prepared for display
        if (unitToDisplay) {
          selectedGroupUnits.push(unitToDisplay);
          const unitDiv = createUnitDiv(unitToDisplay, true); // Pass the specific unit/trailer object
          targetGroupDiv.appendChild(unitDiv);

          // Attach click handler for individual unit
          unitDiv.onclick = (event) => {
            event.stopImmediatePropagation();
            global.showMainPage = false;
            global.selectedUnitId = unitToDisplay; // Set selected unit to the actual object
            global.selectedGroupUnits = selectedGroupUnits; // Pass the list of units in this group

            displayUnitDetail('UNIT', selectedGroupUnits, unitToDisplay); // Pass the specific unit/trailer object
          };
        } else {
          // Optional: Log if a unit in the group data couldn't be matched
          console.warn(`Unit with ID ${idToLookup} or name ${groupUnit.name} from group data not found in allUnits or its linked trailers.`);
        }
      }
      global.selectedGroupUnits = selectedGroupUnits;
      displayStatusSummary(selectedGroupUnits);
    };

    // ... (rest of the displayMainUnitsGroupsList function remains the same)
    for (const group of unitGroups) {
      const unitGroupDiv = document.createElement('div');
      unitGroupDiv.className = 'unitgroup';
      unitGroupDiv.id = `ug${group.unitGroupId}`;

      const groupNameDiv = document.createElement('div');
      groupNameDiv.className = 'group-name';
      groupNameDiv.innerHTML = group.unitGroupName;
      unitGroupDiv.appendChild(groupNameDiv);

      unitsGroupsListMainContainerDiv.appendChild(unitGroupDiv);

      const isInitiallyExpanded = currentSelectedGroupId > 0 && currentSelectedGroupId === group.unitGroupId;
      if (isInitiallyExpanded) {
        activeGroupDiv = unitGroupDiv;
        renderGroupUnits(unitGroupDiv, group);
        updateMetricControls(true);
      }

      unitGroupDiv.onclick = function (e) {
        e.stopImmediatePropagation();

        const clickedGroupId = group.unitGroupId;

        if (activeGroupDiv && activeGroupDiv !== this) {
          const prevGroupNameDiv = activeGroupDiv.querySelector('.group-name');
          clearChildren(activeGroupDiv);
          if (prevGroupNameDiv) activeGroupDiv.appendChild(prevGroupNameDiv);
        }

        if (activeGroupDiv === this && global.selectedGroupId === clickedGroupId) {
          global.selectedGroupId = 0;
          global.selectedGroupUnits = [];
          const currentGroupNameDiv = this.querySelector('.group-name');
          clearChildren(this);
          if (currentGroupNameDiv) this.appendChild(currentGroupNameDiv);

          displayStatusSummary([]);
          updateMetricControls(false);
          activeGroupDiv = null;
        } else {
          global.selectedGroupId = clickedGroupId;
          activeGroupDiv = this;
          renderGroupUnits(this, group);
          updateMetricControls(true);
        }
      };
    }

    if (global.selectedGroupId === 0 || !activeGroupDiv) {
      displayStatusSummary([]);
      updateMetricControls(false);
    }

  } catch (e) {
    console.error("Error in displayMainUnitsGroupsList:", e);
  }
}

export async function displayMainUnitsGroupsList1(units) {
  try {
    const unitGroups = await getUnitGroupData();
    global.unitGroups = unitGroups;
    global.units = units; // Store all units globally for broader access

    const unitsGroupsListMain = document.getElementById('unitslistmain');
    clearChildren(unitsGroupsListMain); // Clear existing content

    // Create the main container for unit groups
    const unitsGroupsListMainContainerDiv = document.createElement('div');
    unitsGroupsListMainContainerDiv.id = 'unitgroupslistcontainer';
    unitsGroupsListMainContainerDiv.className = 'unitslistcontainer';
    unitsGroupsListMain.appendChild(unitsGroupsListMainContainerDiv);

    let activeGroupDiv = null; // Reference to the currently expanded unit group div
    const currentSelectedGroupId = global.selectedGroupId;

    // Create a Map for efficient unit lookup by unitId
    const unitsById = new Map();
    for (const unit of units) {
      unitsById.set(unit.unitId, unit);

      if (unit.trailers && Array.isArray(unit.trailers)) {
        for (const trailer of unit.trailers) {
          if (trailer.Id) { // Assuming trailer object has an 'Id' property
            unitsById.set(trailer.Id, unit); // Map trailer's ID to its parent truck
          }
        }
      }
    }

    // Function to render units within a given group div
    const renderGroupUnits = (targetGroupDiv, groupData) => {
      // Remove any previously rendered unit divs, but keep the group name
      const existingGroupNameDiv = targetGroupDiv.querySelector('.group-name');
      clearChildren(targetGroupDiv);
      if (existingGroupNameDiv) {
        targetGroupDiv.appendChild(existingGroupNameDiv);
      } else {
        // If group name wasn't in a specific div, re-add it directly if cleared
        targetGroupDiv.innerHTML = `${groupData.unitGroupName}`;
      }

      const selectedGroupUnits = [];
      const combinedGroupUnits = [...groupData.trucks, ...groupData.trailers];

      for (const groupUnit of combinedGroupUnits) {
        const matchedUnit = unitsById.get(groupUnit.unitId); // Efficient lookup by ID

        // Ensure the unit is found and name matches for full validation
        if (matchedUnit && matchedUnit.name === groupUnit.name) {
          selectedGroupUnits.push(matchedUnit); // Add the actual unit object from 'units'
          const unitDiv = createUnitDiv(matchedUnit, true); // Pass the actual unit object
          targetGroupDiv.appendChild(unitDiv);

          // Attach click handler for individual unit
          unitDiv.onclick = (event) => {
            event.stopImmediatePropagation(); // Prevent group div click from firing
            global.showMainPage = false;
            global.selectedUnitId = matchedUnit; // Set selected unit to the actual unit object
            global.selectedGroupUnits = selectedGroupUnits; // Pass the list of units in this group

            displayUnitDetail('UNIT', selectedGroupUnits, matchedUnit);
          };
        }
      }
      global.selectedGroupUnits = selectedGroupUnits;
      displayStatusSummary(selectedGroupUnits);
    };

    for (const group of unitGroups) {
      const unitGroupDiv = document.createElement('div');
      unitGroupDiv.className = 'unitgroup';
      unitGroupDiv.id = `ug${group.unitGroupId}`; // Ensure ID is unique by prefixing

      // Create a dedicated div for the group name to simplify clearing unit children later
      const groupNameDiv = document.createElement('div');
      groupNameDiv.className = 'group-name';
      groupNameDiv.innerHTML = group.unitGroupName;
      unitGroupDiv.appendChild(groupNameDiv);

      unitsGroupsListMainContainerDiv.appendChild(unitGroupDiv);

      // Handle initial expansion if a group was previously selected
      const isInitiallyExpanded = currentSelectedGroupId > 0 && currentSelectedGroupId === group.unitGroupId;
      if (isInitiallyExpanded) {
        activeGroupDiv = unitGroupDiv;
        renderGroupUnits(unitGroupDiv, group);
        updateMetricControls(true); // Enable controls for an expanded group
      }

      // Click handler for the group div (expand/collapse functionality)
      unitGroupDiv.onclick = function (e) {
        e.stopImmediatePropagation();

        const clickedGroupId = group.unitGroupId; // Get the ID of the clicked group

        // Collapse the previously active group if it's different from the clicked one
        if (activeGroupDiv && activeGroupDiv !== this) {
          // Reset its content, keeping only the group name
          const prevGroupNameDiv = activeGroupDiv.querySelector('.group-name');
          clearChildren(activeGroupDiv);
          if (prevGroupNameDiv) activeGroupDiv.appendChild(prevGroupNameDiv);
        }

        // Toggle the clicked group's state
        if (activeGroupDiv === this && global.selectedGroupId === clickedGroupId) {
          // Group was already expanded and is now being collapsed
          global.selectedGroupId = 0; // No group selected
          global.selectedGroupUnits = [];
          // Clear its units (already handled above by `activeGroupDiv !== this` block if needed, or by clearChildren inside)
          const currentGroupNameDiv = this.querySelector('.group-name');
          clearChildren(this);
          if (currentGroupNameDiv) this.appendChild(currentGroupNameDiv);

          displayStatusSummary([]); // Show summary for all units
          updateMetricControls(false); // Disable controls
          activeGroupDiv = null; // No group is active
        } else {
          // Expand this group
          global.selectedGroupId = clickedGroupId;
          activeGroupDiv = this; // Set this group as the active one
          renderGroupUnits(this, group); // Render units for the clicked group
          updateMetricControls(true); // Enable controls
        }
      };
    }

    // Handle initial display for metric controls and status summary
    // This runs if no group was initially selected or if a selected group is now collapsed
    if (global.selectedGroupId === 0 || !activeGroupDiv) {
      displayStatusSummary([]); // Show summary for all units by default
      updateMetricControls(false); // Disable controls if no group is expanded
    }

  } catch (e) {
    console.error("Error in displayMainUnitsGroupsList:", e);
    // Implement a user-friendly error display here if needed
  }
}

export function openNewUnitGroupForm() {

  document.getElementById("newgroupform").reset();
  let newUnitGroupModal = document.getElementById('newunitgroupmodal');
  let closeModal = document.getElementById("closenewunitgroupmodal");
  closeModal.onclick = function () {
    newUnitGroupModal.style.display = "none";
  };

  window.onclick = function (event) {
    if (event.target == newUnitGroupModal) {
      newUnitGroupModal.style.display = "none";
    }
  };

  let btnSubmitGroup = document.getElementById('btnsubmitnewunitgroup');
  btnSubmitGroup.onclick = async (e) => {
    e.stopImmediatePropagation();
    document.body.style.cursor = 'wait';
    const unitGroupName = document.getElementById('groupname').value;
    const units = [];
    try {
      document.body.style.cursor = 'wait';
      const newGroup = await createUnitGroup(unitGroupName, units);
      if (unitGroupName === newGroup.unitGroupName) {
        console.log('Unit Group Created:', newGroup);
      }
    } catch (error) {
      console.error('Error Creating Unit Group:', error);
      alert(`Error creating Unit Group: ${error}. Try again.`);
    }
    newUnitGroupModal.style.display = 'none';
    //$('#container').overlayMask('hide');
    //$("#loadingBox").modal("hide");
    document.body.style.cursor = 'default';
    return false;
  };

  newUnitGroupModal.style.display = 'block';
}

export const openEditDeleteUnitsGroupForm = async (units) => {

  document.body.style.cursor = 'wait';
  //$('#container').overlayMask();

  const editDeleteGroupModal = document.getElementById('editdeletegroupmodal');

  const closeModal = document.getElementById("closeeditdeletegroupmodal");
  closeModal.onclick = function () {
    editDeleteGroupModal.style.display = 'none';
  };

  window.onclick = function (event) {
    if (event.target == editDeleteGroupModal) {
      editDeleteGroupModal.style.display = 'none';
    }
  };

  gEditUnitGroup = true;
  const unitGroups = await populateUnitGroupsSelect(gEditUnitGroup);

  let selectedGroupId = "";
  let groupName = "";
  const unitGroupsSelect = document.getElementById('editdeleteunitgroup');
  unitGroupsSelect.onchange = (e) => {
    e.stopImmediatePropagation();
    selectedGroupId = unitGroupsSelect.options[unitGroupsSelect.selectedIndex].value;
    groupName = unitGroupsSelect.options[unitGroupsSelect.selectedIndex].text;
    document.getElementById('editgroupname').value = groupName;
    return false;
  };

  const btneditgroupname = document.getElementById('btneditgroupname');
  btneditgroupname.onclick = async (e) => {
    e.stopImmediatePropagation();
    try {
      document.body.style.cursor = 'wait';
      const unitGroup = unitGroups.find(ug => ug.unitGroupId === selectedGroupId);
      const updatedUnitGroup = await updateUnitGroupName(unitGroup, document.getElementById('editgroupname').value);
      if (updatedUnitGroup) {
        console.log("Unit Group successfully renamed.");
        displayMainPane(units);
      }
    } catch (error) {
      console.error(`Unit group NOT renamed: ${error}`);
      alert(`Unit group NOT renamed: ${error}. Try again.`);
    }
    editDeleteGroupModal.style.display = 'none';
    document.body.style.cursor = 'default';
    return false;
  };

  const btndeletegroupname = document.getElementById('btndeletegroupname');
  btndeletegroupname.onclick = async (e) => {
    e.stopImmediatePropagation();
    try {
      document.body.style.cursor = 'wait';
      const deletedGroup = await deleteUnitGroup(selectedGroupId);
      if (deletedGroup) {
        console.log("Unit group deleted successfully");
        displayMainPane(units);
      }
    } catch (error) {
      console.error(`Unit group NOT deleted: ${error}`);
      alert(`Unit group NOT deleted: ${error}. Try again.`);
    }
    editDeleteGroupModal.style.display = 'none';
    document.body.style.cursor = 'default';
    return false;
  };

  document.getElementById("editdeletegroupform").reset();
  editDeleteGroupModal.style.display = "block";

  //$('#container').overlayMask('hide');
  document.body.style.cursor = 'default';

  return false;
};

const populateUnitGroupList = async (selectedGroupId, unitGroups) => {

  const clearSelectOptions = (selectElement) => {
    while (selectElement.options.length > 0) {
      selectElement.options.remove(0);
    }
  };

  const appendOption = (selectElement, value, text, type) => {
    const option = document.createElement("option");
    option.value = value;
    option.text = text;
    if (type) {
      option.dataset.type = type; // Set data-type attribute
    }
    selectElement.appendChild(option);
  };

  const fetchUnits = async () => {
    const [trucksData, trailersData] = await Promise.all([fetchTrucks(), fetchTrailers()]);

    // Add a 'type' property to each unit
    const trucksWithType = trucksData.map(unit => ({ ...unit, type: 'truck' }));
    const trailersWithType = trailersData.map(unit => ({ ...unit, type: 'trailer' }));

    return [...trucksWithType, ...trailersWithType].sort((a, b) => a.name.localeCompare(b.name));
  };

  const allUnits = await fetchUnits();

  const selectedGroup = unitGroups.find(g => g.unitGroupId === selectedGroupId);
  const assignedGroupUnits = selectedGroup ?
    [...selectedGroup.trucks, ...selectedGroup.trailers].sort((a, b) => a.name.localeCompare(b.name)) : [];

  const assignedUnitsList = document.getElementById('assignedunits');
  clearSelectOptions(assignedUnitsList);

  const assignedUnitIds = new Set(assignedGroupUnits.map(unit => unit.unitId));

  for (const groupUnit of assignedGroupUnits) {
    // Find the corresponding unit from allUnits to get its current details (Id, name, and type)
    const matchedUnit = allUnits.find(unit => unit.Id === groupUnit.unitId && unit.name === groupUnit.name);

    if (matchedUnit) {
      appendOption(assignedUnitsList, matchedUnit.Id, matchedUnit.name, matchedUnit.type);
    } else {
      // Fallback if a unit in the group isn't found in allUnits (should ideally not happen if data is consistent)
      // If no match, we might not have the type readily, you'd need to infer or handle this case
      appendOption(assignedUnitsList, groupUnit.unitId, groupUnit.unitName, 'unknown'); // Or handle appropriately
    }
  }

  const assignUnitsList = document.getElementById('assignunits');
  clearSelectOptions(assignUnitsList);

  const unitsToAssign = allUnits.filter(unit => !assignedUnitIds.has(unit.Id));

  for (const unit of unitsToAssign) {
    appendOption(assignUnitsList, unit.Id, unit.name, unit.type);
  }
};


export function openAssignUnitsGroupForm(units) {

  document.body.style.cursor = 'wait';

  const assignUnitsGroupModal = document.getElementById('assignunitsgroupmodal');

  const assignUnitsList = document.getElementById('assignunits');
  while (assignUnitsList.options.length) assignUnitsList.options.remove(0);

  const assignedUnitsList = document.getElementById('assignedunits');
  while (assignedUnitsList.options.length) assignedUnitsList.options.remove(0);

  let closeModal = document.getElementById("closeassignunitsgroupmodal");
  closeModal.onclick = function () {
    assignUnitsGroupModal.style.display = 'none';
  };

  window.onclick = function (event) {
    if (event.target == assignUnitsGroupModal) {
      assignUnitsGroupModal.style.display = 'none';
    }
  };

  gEditUnitGroup = false;
  populateUnitGroupsSelect(gEditUnitGroup);

  let selectedGroupId = 0;
  let unitGroups = []; // This will hold the unit group data
  const unitGroupsSelect = document.getElementById('newunitgroup');

  // Initial population when the form opens and a group is selected by default
  // We need to trigger this initially as well, not just on change
  // You might want to get the initial selectedGroupId from the dropdown
  // and call populateUnitGroupList immediately when the form opens.
  // selectedGroupId = unitGroupsSelect.options[unitGroupsSelect.selectedIndex]?.value || 0; // Get initial selected value
  // // Fetch unit groups once the form opens, or handle it as part of initialization if they're global
  // getUnitGroupData().then(data => {
  //     unitGroups = data;
  //     populateUnitGroupList(selectedGroupId, unitGroups); // Populate lists initially
  // });

  unitGroupsSelect.addEventListener('change', async function () {
    selectedGroupId = unitGroupsSelect.options[unitGroupsSelect.selectedIndex].value;
    // unitGroups is already fetched, but if it needs to be refreshed per change, keep this line:
    unitGroups = await getUnitGroupData(); // Re-fetch if group data can change
    populateUnitGroupList(selectedGroupId, unitGroups);
  });

  // jQuery click handlers remain largely the same, but the cloned options will retain data-attributes
  $("#btnRight").click(function (e) {
    let selectedOpts = $("#assignunits option:selected");
    if (selectedOpts.length == 0) {
      e.preventDefault();
      return; // Exit if nothing to move
    }
    $("#assignedunits").append(selectedOpts.clone()); // .clone() preserves data attributes
    selectedOpts.remove();
    e.preventDefault();
  });
  $("#btnAllRight").click(function (e) {
    let selectedOpts = $("#assignunits option");
    if (selectedOpts.length == 0) {
      e.preventDefault();
      return;
    }
    $("#assignedunits").append(selectedOpts.clone());
    selectedOpts.remove();
    e.preventDefault();
  });
  $("#btnLeft").click(function (e) {
    let selectedOpts = $("#assignedunits option:selected");
    if (selectedOpts.length === 0) {
      e.preventDefault();
      return;
    }
    $("#assignunits").append(selectedOpts.clone());
    selectedOpts.remove();
    e.preventDefault();
  });
  $("#btnAllLeft").click(function (e) {
    let selectedOpts = $("#assignedunits option");
    if (selectedOpts.length == 0) {
      e.preventDefault();
      return;
    }
    $("#assignunits").append(selectedOpts.clone());
    selectedOpts.remove();
    e.preventDefault();
  });

  document.body.style.cursor = 'default';

  let assignunitsgroupform = document.getElementById('assignunitsgroupform');
  assignunitsgroupform.addEventListener('submit', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let assignUnits = [];
    const assignedUnitsSelectElement = document.getElementById('assignedunits');

    // Iterate over the options in the assignedUnits list
    // Now you can get the type here!
    for (let i = 0; i < assignedUnitsSelectElement.options.length; i++) {
      const option = assignedUnitsSelectElement.options[i];
      // assignUnits.push({
      //     unitId: option.value,
      //     unitName: option.text, // You might need this if updateUnitGroupUnits expects it
      //     unitType: option.dataset.type // Get the type from data-type attribute
      // });
      assignUnits.push(
        option.value
      );
    }

    const unitGroup = unitGroups.find(ug => ug.unitGroupId === selectedGroupId);

    // Make sure updateUnitGroupUnits can handle the new structure of assignUnits
    const unitsAssigned = await updateUnitGroupUnits(unitGroup, assignUnits);
    if (unitsAssigned) {
      document.getElementById("assignunitsgroupmodal").style.display = 'none';
      displayMainPane(units);
    }
  });

  document.getElementById("assignunitsgroupmodal").style.display = "block";

  return false;
}

async function populateUnitGroupsSelect(gEditUnitGroup) {

  let unitGroupsSelect = document.getElementById('newunitgroup');
  if (gEditUnitGroup)
    unitGroupsSelect = document.getElementById('editdeleteunitgroup');

  while (unitGroupsSelect.options.length) unitGroupsSelect.options.remove(0);
  unitGroupsSelect.value = "";
  const unitGroups = await getUnitGroupData();
  const unitGroupOption = document.createElement("option");
  unitGroupOption.value = "";
  unitGroupOption.text = " -- select a group --";
  unitGroupOption.hidden = true;
  unitGroupsSelect.appendChild(unitGroupOption);
  for (const unitGroup of unitGroups) {
    const unitGroupOption = document.createElement("option");
    unitGroupOption.value = unitGroup.unitGroupId;
    unitGroupOption.text = unitGroup.unitGroupName;
    unitGroupsSelect.appendChild(unitGroupOption);
  }
  return unitGroups;
}


